module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    style: (_vm.style)
  }, [(_vm.renaming) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.renamingLabel),
      expression: "renamingLabel"
    }, {
      name: "focusoninsert",
      rawName: "v-focusoninsert"
    }],
    staticClass: "input--rename",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.renamingLabel)
    },
    on: {
      "blur": _vm.handleRename,
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.handleRename($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.renamingLabel = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    ref: "label",
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.item.label))]), _vm._v(" "), _c('span', {
    staticClass: "remove-button",
    on: {
      "click": function($event) {
        _vm.removeArea(_vm.item)
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('div', {
    ref: "resizeHandle",
    staticClass: "resize-handle"
  }, [_c('img', {
    staticClass: "img--resize_handle",
    attrs: {
      "src": "static/img/resize.svg"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41873822","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GridItem.vue
// module id = 73
// module chunks = 1